goog.module('yext.developerapps.tableauconnector.ReportSelector');
goog.module.declareLegacyNamespace();

require('jquery-ui/ui/widgets/datepicker');

/**
 * @suppress {deprecated}
 */
class ReportSelector {
  constructor() {
    this.setMaxDate = this.setMaxDate.bind(this);
    this.getMaxDate = this.getMaxDate.bind(this);
    this.setConnectionData = this.setConnectionData.bind(this);
    this.getDatePicker = this.getDatePicker.bind(this);
    this.bindOptions = this.bindOptions.bind(this);
    this.setCustomDateInputs = this.setCustomDateInputs.bind(this);
    this.showCustomDates = this.showCustomDates.bind(this);
    this.showReportSettings = this.showReportSettings.bind(this);

    this.bindResetError = this.bindResetError.bind(this);
    this.bindDataTypeChanges = this.bindDataTypeChanges.bind(this);
    this.bindDateRangeChanges = this.bindDateRangeChanges.bind(this);
    this.bindCustomDateChanges = this.bindCustomDateChanges.bind(this);
    this.init = this.init.bind(this);
  }

  init(connectionData) {
    this.setConnectionData(connectionData);
    this.bindOptions();
    this.bindResetError();
    this.bindDataTypeChanges();
    this.bindDateRangeChanges();
    this.bindCustomDateChanges();

    this.setMaxDate(Date.now());
    this.getDatePicker();

    this.showReportSettings();

    if (this.connectionData.isDateRange('custom')) {
      this.showCustomDates();
    }
  }

  setMaxDate(maxDate) {
    this.maxDate = maxDate;
  }

  getMaxDate() {
    return this.maxDate;
  }

  setConnectionData(connectionData) {
    this.connectionData = connectionData;
    console.log('reportSelector.connectionData: ' + JSON.stringify(connectionData));
  }

  /* Initialize and create event listeners for jquery DatePicker fields*/
  getDatePicker() {
    var maxDate = new Date(this.maxDate);
    var dateFormat = 'mm/dd/yy';
    var from = $( '#from' ).datepicker({
      changeMonth: true,
      numberOfMonths: 1,
    });

    let self = this;

    from.on( 'change', function() {
      var date = this.value;
      if (isNaN(Date.parse(date))) {
        date = maxDate;
      } else {
        date = $.datepicker.parseDate(dateFormat, this.value);
      }
      self.setDatePickerMinDate(to, date);
    });

    var to = $( '#to' ).datepicker({
      changeMonth: true,
      numberOfMonths: 1,
    });

    to.on( 'change', function() {
      var date = this.value;
      if (isNaN(Date.parse(date))) {
        date = maxDate;
      } else {
        date = $.datepicker.parseDate(dateFormat, this.value);
      }
      self.setDatePickerMaxDate(from, date);
    });

    this.setDatePickerMaxDate(from, maxDate);
  }

  setDatePickerMaxDate($el, maxDate) {
    $el.datepicker('option', 'maxDate', maxDate);
  }

  setDatePickerMinDate($el, minDate) {
    $el.datepicker('option', 'minDate', minDate);
  }

  /* Add report dropdown options */
  bindOptions() {
    var that = this;
    $(document).find('.js-field').each(function() {
      var $select = $(this);
      var optionType = $select.data('source');
      console.log('Found optionType: ' + optionType);
      console.log('connectionData: ' + JSON.stringify(that.connectionData.getJson()));
      // 1. clear options
      $select.find('option');

      var optionEnum;
      if (optionType == 'data') {
        optionEnum = ReportSelector.DataTypes;
      } else {
        optionEnum = ReportSelector.DateRanges;
      }
      var options = Object.keys(optionEnum);

      // 2. rebuild options
      for (var i = 0; i < options.length; i++) {
        var currOption = optionEnum[options[i]];
        var label = currOption.label;
        var name = currOption.name;

        var $option = $('<option></option>')
          .attr('value', name)
          .text(label);

        console.log('options: ' + name + ', optionType: ' + that.connectionData.getJson()[optionType]);

        if (name == that.connectionData.getJson()[optionType]) {
          $option.attr('selected', 'selected');
        }

        $select.append($option);
      }
    });
  }

  setCustomDateInputs() {
    var startDate = this.connectionData.getStartDate();
    var endDate = this.connectionData.getEndDate();

    console.log('setCustomDateValues startDate: ' + startDate);
    console.log('setCustomDateValues endDate: ' + endDate);

    if (startDate && startDate.length > 0) {
      $('#from').val(startDate);
      this.setDatePickerMinDate($('#to'), new Date(Date.parse(startDate)));
    }

    if (endDate && endDate.length > 0) {
      $('#to').val(endDate);
      this.setDatePickerMaxDate($('#from'), new Date(Date.parse(endDate)));
    }
  }

  bindDataTypeChanges() {
    var that = this;
    $(document).on('change', '.js-field.data', function() {
      var $this = $(this);
      that.connectionData.setDataType($this.val());
      console.log('onchange connectionData: ' + JSON.stringify(that.connectionData.getJson()));
    });
  }

  bindDateRangeChanges() {
    var that = this;
    $(document).on('change', '.js-field.date-range', function() {
      var $this = $(this);
      console.log('change value: ' + $this.val());
      that.connectionData.setDateRange($this.val());

      if (that.connectionData.isDateRange('custom')) {
        that.showCustomDates();
      } else {
        that.hideCustomDates();
      }
      console.log('onchange connectionData: ' + JSON.stringify(that.connectionData.getJson()));
    });
  }

  bindCustomDateChanges() {
    var that = this;
    $(document).on('change', '.js-custom-dates', function() {
      that.connectionData.setStartDate($('#from').val());
      that.connectionData.setEndDate($('#to').val());

      console.log('startDate: ' + Date.parse($('#from').val()) + '; endDate: ' + Date.parse($('#to').val()));

      console.log('onchange connectionData: ' + JSON.stringify(that.connectionData.getJson()));
    });
  }

  bindResetError() {
    var that = this;
    $(document).on('change', '.js-report-settings', function() {
      that.hideError(); // Hide error by default on next change
    });
  }

  showReportSettings() {
    $( '.js-report-settings' ).show();
  }

  showCustomDates() {
    this.setCustomDateInputs();
    $( '.js-custom-dates' ).show();
  }

  hideCustomDates() {
    $( '.js-custom-dates' ).hide();
  }

  showGenericError(errorMsg) {
    $('.js-general-error').text(errorMsg).show();
  }

  hideError() {
    $('.js-general-error').hide();
  }
}

ReportSelector.DataTypes = {
  ANALYTICS: {name: 'analytics', label: 'Analytics'},
  REVIEWS: {name: 'reviews', label: 'Reviews'},
};

ReportSelector.DateRanges = {
  NINETY_DAY: {name: '90-day', label: '90 Days'},
  LAST_YEAR: {name: 'last-year', label: 'Last Year'},
  // ALL_TIME: {name : "all-time", label : "All Time"}, //TODO(PET): Add back after OOM fix
  CUSTOM: {name: 'custom', label: 'Custom Date Range'},
};


exports = ReportSelector;
